import { render, staticRenderFns } from "./InstructionParameterAppendPrepend.vue?vue&type=template&id=3b70aa51&"
import script from "./InstructionParameterAppendPrepend.vue?vue&type=script&lang=js&"
export * from "./InstructionParameterAppendPrepend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports